import * as React from 'react';
import { useId } from '../../hooks/use-id.js';
import { renderWithRef } from '../core/render-with-ref.js';
import 'tiny-warning';
import { RenderComp } from '../core/render-comp.component.js';
import { usePriceBarQuantityContext } from './price-bar.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const PriceBarQuantityAmount = renderWithRef('PriceBarQuantityAmount', null, (props, ref) => {
  const classNames = new Set(['swan-price-bar-button-quantity-amount']);
  const {
    id: customId,
    children
  } = props;
  const {
    buttonId,
    setButtonId,
    labelId
  } = usePriceBarQuantityContext();
  const id = useId(customId);
  React.useEffect(() => {
    setButtonId(id);
    return () => setButtonId(undefined);
  }, [id, setButtonId]);
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: "span",
    forwardedRef: ref,
    classNames: classNames,
    props: _objectSpreadProps(_objectSpread({}, props), {
      id: buttonId,
      'aria-labelledby': labelId
    })
  }, children);
});
export { PriceBarQuantityAmount };